export { ReactComponent as TumHeaderLogo } from './header-logo.svg';
